import PropTypes from 'prop-types';

import { styled } from '@mui/material/styles';

import { FormattedText } from '#client/pages/EducationStudio/components/FormattedText/FormattedText';

const StyledListItem = styled('li')({
  marginBottom: '.5rem',
  '&:last-child': {
    marginBottom: 0
  },
  '& p': {
    margin: 0
  }
});

const StyledUL = styled('ul')({
  paddingLeft: '1rem',
  margin: 0
});

export const BulletList = ({ listItems, className }) => (
  <StyledUL className={className} title="Article Bullet List">
    { listItems.map((item) => (
      <StyledListItem key={item.key}>
        <FormattedText tag="span" size="md" dirtyText={item.text} />
      </StyledListItem>
    )) }
  </StyledUL>
);

BulletList.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired
  })),
  className: PropTypes.string
};
